<template>
  <div class="heading">
    <h2>{{ title }}</h2>

    <div class="heading-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'heading',
  props: {
    title: {
      default: '',
      type: String
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';

.heading {
  align-items: center;
  border-bottom: 1px solid $color-border-light;
  display: flex;
  height: 8.4rem;
  width: 100%;

  h2 {
    font-size: 2.4rem;
    font-weight: 400;
    margin: 0;
  }

  &-content {
    align-items: center;
    display: flex;
    margin-left: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/Heading.vue